import { ToastSink } from '../../../services/toast.service';
import { ApiResponse } from '../../../shared/types';
import { Company, CompanyService } from '../../services/company.service';

/** Shared company-load handler for staff/tunnel impersonation pages (company dropdown). */
export function loadImpersonationCompanies(
  companyService: CompanyService,
  setLoading: (loading: boolean) => void,
  setCompanies: (companies: Company[]) => void,
  setError: (message: string) => void
): void {
  setLoading(true);
  companyService.listCompaniesPaginated({ page: 1, limit: 500 }).subscribe({
    next: res => {
      setLoading(false);
      const companies = res.status && res.data ? res.data.companies || [] : [];
      setCompanies(companies);
      if (!companies.length) {
        setError(res.message || 'No shops available.');
      }
    },
    error: err => {
      setLoading(false);
      setError(err?.error?.message || err?.message || 'Failed to load shops.');
    },
  });
}

export function notifyImpersonationFailure(
  messageService: ToastSink,
  detail: string
): void {
  messageService.add({
    severity: 'error',
    summary: 'Impersonation failed',
    detail,
    life: 5000,
  });
}

export function handleImpersonationApiResult<T>(
  res: ApiResponse<T>,
  onSuccess: (data: T) => boolean,
  messageService: ToastSink,
  missingTokenDetail: string
): void {
  if (res.status && res.data) {
    if (onSuccess(res.data)) {
      return;
    }
  }
  notifyImpersonationFailure(messageService, res.message || missingTokenDetail);
}
